/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');


import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/es';
import money from 'v-money';

/* import  fileInput from 'bootstrap-fileinput'; */
/* import locale-file from 'bootstrap-fileinput' */

import vSelect from 'vue-select';

Vue.use(ElementUI, { locale })


import Swal from 'sweetalert2'
window.Swal = Swal;

/**
 * EventBus - biblioteca para comunicacion entre componentes
 */
export const EventBus = new Vue();
window.EventBus = EventBus;

import moment from 'moment';
moment.locale('es');
window.moment = moment;

/**
 * Vuesax - biblioteca para interfaz de usuario
 */
import Vuesax from 'vuesax'
import 'vuesax/dist/vuesax.css' //Vuesax styles


Vue.prototype.$pageLoad = function (estado) {
    const loading = this.$loading({
        lock: true,
        text: 'Cargando...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
    });
    if (estado) {
        loading.close();
    }
}

//Funcion para eliminar la session
Vue.prototype.$confirmar_session = function () {
    this.$router.push({ name: 'login' })
    localStorage.clear();
    location.reload();
    this.$pageLoad(true);
}

Vue.prototype.$mostrar_error = function (error) {

    this.$pageLoad(true);
    console.error(error);

    if (!error.hasOwnProperty('response') || !error.hasOwnProperty('response.status')) {

        Swal.fire({
            icon: 'error',
            title: 'Error de cliente',
            html: '<b>Detalle del error</b>:<br>' + error,
            footer: '<b>Contactar con el administrador</b>'
        })

    } if (error.response.status == 401 || error.response.status == 419) {
        this.$confirmar_session();
    } else {
        Swal.fire({
            icon: 'error',
            title: 'Error de servidor',
            html: '<b>Detalle del error</b>:<br>' + error.response.data.message,
            footer: '<b>Contactar con el administrador</b>'
        })
    }
}




Vue.use(Vuesax, {
    // options here
})

Vue.prototype.$formato_moneda = function (valor){
    let val = (valor / 1).toFixed(2).replace(".", ",");
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}
/*input-file */
/* Vue.use(fileInput, {
    // options here
}) */

/*Libreria de Moneda */
Vue.use(money, {precision: 2})

/**Libreria de select */
Vue.component("v-select", vSelect);
Vue.component('App', require('./components/Principal.vue').default);
Vue.component('Auth', require('./components/Auth.vue').default);



 import router from './routes';


const app = new Vue({
    //mixins: [funcionAlert],
    el: '#app',
    router,
    //
    data: {
        iva_igv: 0.0,

    },
    mounted() {

    },

});



